import { type EditStore } from '../state/types';

const getStep = (state: EditStore) => {
	return state.step;
};

const getDetailVariant = (state: EditStore) => {
	return state.rotationDetailVariant;
};

const getOrderRotationLoading = (state: EditStore) => {
	return state.orderRotationLoading;
};

const getInitialRotation = (state: EditStore) => {
	return state.initialRotation;
};

const getRecipientUpdate = (state: EditStore) => {
	return state.recipientUpdate;
};

export const selectors = {
	getStep,
	getDetailVariant,
	getRecipientUpdate,
	getInitialRotation,
	getOrderRotationLoading,
};
